import { jsxs as m, jsx as e, Fragment as L } from "react/jsx-runtime";
import { Heading as E } from "@instructure/ui-heading";
import { View as r } from "@instructure/ui-view";
import { Button as S } from "@instructure/ui-buttons";
import { TextArea as W } from "@instructure/ui-text-area";
import { TextInput as N } from "@instructure/ui-text-input";
import { Flex as k } from "@instructure/ui-flex";
import { Spinner as R } from "@instructure/ui-spinner";
import { Text as s } from "@instructure/ui-text";
import { useState as a } from "react";
const V = {
  somethingBroke: () => "Sorry, Something Broke",
  helpUsImprove: () => "Help us improve by telling us what happened",
  reportIssue: () => "Report Issue",
  loading: () => "Loading",
  commentSubmitted: () => "Comment submitted!",
  commentFailed: () => "Comment failed to post! Please try again later.",
  whatHappened: () => "What happened?",
  yourEmailAddress: () => "Your Email Address",
  emailPlaceholder: () => "email@example.com",
  submit: () => "Submit"
};
function U({ imageUrl: t, title: o }) {
  return /* @__PURE__ */ m(r, { display: "block", children: [
    /* @__PURE__ */ e(E, { level: "h1", children: o }),
    /* @__PURE__ */ e(r, { maxWidth: "16rem", margin: "large auto", display: "block", "aria-hidden": !0, children: /* @__PURE__ */ e("img", { alt: "", src: t }) })
  ] });
}
function q({
  textAreaComment: t,
  email: o,
  onChangeComment: l,
  onChangeEmail: c,
  onSubmit: h,
  translations: n
}) {
  const u = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(o) ? "enabled" : "disabled";
  return /* @__PURE__ */ m(r, { margin: "small", children: [
    /* @__PURE__ */ e(
      W,
      {
        onChange: l,
        label: n.whatHappened(),
        value: t
      }
    ),
    /* @__PURE__ */ e(r, { margin: "small", children: /* @__PURE__ */ e(
      N,
      {
        onChange: c,
        renderLabel: n.yourEmailAddress(),
        isRequired: !0,
        placeholder: n.emailPlaceholder(),
        value: o
      }
    ) }),
    /* @__PURE__ */ e(r, { textAlign: "end", display: "block", children: /* @__PURE__ */ e(S, { margin: "small 0", color: "primary", interaction: u, onClick: h, children: n.submit() }) })
  ] });
}
function _({
  errorSubject: t = "No Error Subject",
  errorCategory: o = "No Error Category",
  errorMessage: l = "No Error Message",
  imageUrl: c,
  stack: h,
  showDevError: n = !1,
  translations: i = V,
  onReportError: u
}) {
  const [v, p] = a(!1), [f, w] = a(!1), [b, g] = a(!1), [A, y] = a(!1), [x, P] = a(""), [C, B] = a(""), I = () => {
    p(!0);
  }, T = (d) => {
    B(d.target.value);
  }, F = (d) => {
    P(d.target.value);
  }, j = async () => {
    const d = typeof window < "u" ? window.location.href : "", H = {
      subject: t,
      category: o,
      message: l,
      url: d,
      comments: C,
      email: x,
      backtrace: h
    };
    y(!0), g(!1);
    try {
      (await u(H)).logged ? (w(!0), p(!1)) : g(!0);
    } catch {
      g(!0);
    } finally {
      y(!1);
    }
  };
  return /* @__PURE__ */ m(
    r,
    {
      as: "div",
      width: "100%",
      height: "100%",
      margin: "large auto",
      textAlign: "center",
      display: "block",
      children: [
        /* @__PURE__ */ e(U, { imageUrl: c, title: i.somethingBroke() }),
        /* @__PURE__ */ m(r, { margin: "small", display: "block", children: [
          /* @__PURE__ */ e(k, { justifyItems: "center", children: /* @__PURE__ */ e(k.Item, { children: n && l && /* @__PURE__ */ e("pre", { style: { textAlign: "left" }, children: l }) }) }),
          !f && /* @__PURE__ */ m(L, { children: [
            /* @__PURE__ */ e(r, { margin: "small", display: "block", children: /* @__PURE__ */ e(s, { children: i.helpUsImprove() }) }),
            /* @__PURE__ */ e(r, { margin: "small", display: "block", children: /* @__PURE__ */ e(S, { margin: "0", color: "primary", onClick: I, children: i.reportIssue() }) })
          ] }),
          v && /* @__PURE__ */ e(
            q,
            {
              textAreaComment: C,
              email: x,
              onChangeComment: T,
              onChangeEmail: F,
              onSubmit: j,
              translations: i
            }
          ),
          A && /* @__PURE__ */ e(R, { renderTitle: i.loading(), margin: "0 0 0 medium" }),
          b && /* @__PURE__ */ e(r, { display: "block", "data-testid": "generic-error-post-error", children: /* @__PURE__ */ e(s, { color: "danger", children: i.commentFailed() }) }),
          f && !b && /* @__PURE__ */ e(r, { display: "block", "data-testid": "generic-error-comments-submitted", children: /* @__PURE__ */ e(s, { children: i.commentSubmitted() }) })
        ] })
      ]
    }
  );
}
function M({
  artwork: t,
  title: o = "Whoops... Looks like nothing is here!",
  description: l = "We couldn't find that page!"
}) {
  return /* @__PURE__ */ e("div", { "data-testid": "not-found-page", children: /* @__PURE__ */ m(r, { margin: "large auto", textAlign: "center", display: "block", children: [
    t && /* @__PURE__ */ e(r, { margin: "large auto", maxWidth: "30rem", display: "block", children: t }),
    /* @__PURE__ */ e(E, { level: "h2", as: "h1", margin: "x-small 0 0", children: o }),
    /* @__PURE__ */ e(r, { margin: "small", display: "block", children: /* @__PURE__ */ e(s, { children: l }) })
  ] }) });
}
export {
  U as ErrorPageHeader,
  q as ErrorTextInputForm,
  _ as GenericErrorPage,
  M as NotFoundPage,
  V as defaultTranslations
};
